import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import useScrollAnimation from './hooks/useScrollAnimation';

// Import pages
import Home from './pages/Home';
import Contact from './pages/Contact';
import Introduction from './pages/About/Introduction';
import OurWork from './pages/About/OurWork';
import TheFounder from './pages/About/TheFounder';
import BridalMakeup from './pages/Services/BridalMakeup';
import PartyMakeup from './pages/Services/PartyMakeup';
import EditorialMakeup from './pages/Services/EditorialMakeup';
import MakeupCourses from './pages/Services/MakeupCourses';
import MakeupTutorials from './pages/Services/MakeupTutorials';
import ComingSoon from './components/ComingSoon';
import Terms from './pages/tnc';
import GroomMakeup from './pages/Services/GroomMakeup';
import ScrollToTop from './components/ScrollToTop';
import MakeAnEnquiry from './components/MakeAnEnquiry';
import ProtectedPage from './components/Protectedpage';
import MigrateData from './pages/MigrateData';
import SeedBlogs from './pages/SeedBlogs';
import BlogList from './pages/Blog/BlogList';
import BlogPost from './pages/Blog/BlogPost';
import AdminApp from './admin/AdminApp';

function PublicSite() {
  const location = useLocation();
  useScrollAnimation();

  return (
    <>
      <Navbar />
      <ScrollToTop />
      <div key={location.pathname} className="page-transition">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<Introduction />} />
          <Route path="/our-work" element={<OurWork />} />
          <Route path="/about/the-founder" element={<TheFounder />} />
          <Route path="/bridal-makeup" element={<BridalMakeup />} />
          <Route path="/party-makeup" element={<PartyMakeup />} />
          <Route path="/editorial-makeup" element={<EditorialMakeup />} />
          <Route path="/makeup-courses" element={<MakeupCourses />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route path="/terms-condition" element={<Terms />} />
          <Route path="/tutorials" element={<MakeupTutorials />} />
          <Route path="/groom" element={<GroomMakeup />} />
          <Route path="/make-an-enquiry" element={<MakeAnEnquiry />} />
          <Route path="/NoteToBride" element={<ProtectedPage />} />
          <Route path="/migrate-data" element={<MigrateData />} />
          <Route path="/seed-blogs" element={<SeedBlogs />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
      </div>
      <Footer />
      <WhatsAppButton />
    </>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/admin/*" element={<AdminApp />} />
      <Route path="/*" element={<PublicSite />} />
    </Routes>
  );
}

export default App;
